import { useTranslation } from 'react-i18next';
import { Center, Spinner, VStack } from '@chakra-ui/react';
import { SectionCard } from '@themes/aegix';
import { DetailRow } from '../DetailRow';
import { useIncidentDetail } from '../../../hooks/queries/useIncidents';

interface IncidentDetailOverviewProps {
  incidentId: number;
}

export function IncidentDetailOverview({ incidentId }: IncidentDetailOverviewProps) {
  const { t } = useTranslation();
  const { data: incident, isLoading } = useIncidentDetail(incidentId);

  if (isLoading || !incident) {
    return (
      <Center py={12}>
        <Spinner size="lg" color="button.primary" />
      </Center>
    );
  }

  return (
    <SectionCard title={t('events.incidentDetails', 'Incident Details')}>
      <VStack align="stretch" gap={0}>
        <DetailRow label={t('events.reference', 'Reference')} value={incident.reference_id || '---'} />
        <DetailRow label={t('common.type', 'Type')} value={incident.type_name} />
        <DetailRow label={t('common.school', 'School')} value={`${t('common.school', 'School')} #${incident.school}`} />
        <DetailRow
          label={t('events.started', 'Started')}
          value={new Date(incident.created).toLocaleString()}
        />
      </VStack>
    </SectionCard>
  );
}
